import ContractsMileageUpdateParams from "../../../../../common/services/contracts/mileage/update/contracts-mileage-update-params";
import MileageContractUpdateFormData from "../form/types/mileage-contract-update-form-data";

const create = (
  formData: MileageContractUpdateFormData,
  contractUuid: string,
): ContractsMileageUpdateParams => {
  return {
    contractUuid: contractUuid,
    isActive: formData.isActive ?? undefined,
  };
};

const mileageContractUpdateParamsFactory = {
  create,
};

export default mileageContractUpdateParamsFactory;
